import React from 'react';
import type { CandidatePipelineStep, CandidatePipelineStepId } from '../../../types/hiring';
import { CANDIDATE_TRAIL_LABELS } from '../../../utils/jobOfferLetter';

type Props = {
  steps: CandidatePipelineStep[];
  onSelect?: (id: CandidatePipelineStepId) => void;
};

const CandidatePipeline: React.FC<Props> = ({ steps, onSelect }) => {
  return (
    <nav className="hiring-pipeline" aria-label="Candidate pipeline">
      {steps.map((step, idx) => (
        <React.Fragment key={step.id}>
          {idx > 0 && <span className="hiring-pipeline-sep" aria-hidden>›</span>}
          <button
            type="button"
            className={`hiring-pipeline-step hiring-pipeline-step--${step.state}`}
            disabled={step.state === 'locked' || step.state === 'upcoming'}
            onClick={() => onSelect?.(step.id)}
          >
            {step.id === 'decision' ? step.label : CANDIDATE_TRAIL_LABELS[step.id]}
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default CandidatePipeline;
